import { render, staticRenderFns } from "./AssignedEvaluationsTable.vue?vue&type=template&id=46068e71&"
import script from "./AssignedEvaluationsTable.vue?vue&type=script&lang=js&"
export * from "./AssignedEvaluationsTable.vue?vue&type=script&lang=js&"
import style0 from "./AssignedEvaluationsTable.vue?vue&type=style&index=0&id=46068e71&prod&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports